import Vue from 'vue';
import App from './views/app/App.vue';
import router from './router';
import store from './store/index';
import './registerServiceWorker';
import vuetify from './plugins/vuetify';
import './plugins/vee-validate';
import axios from '@/app-axios';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  created () {
    const userInfo = localStorage.getItem('user');
    if (userInfo) {
      const userData = JSON.parse(userInfo);
      this.$store.commit('setUserData', userData);
    }

    axios.interceptors.response.use(
      response => response,
      error => {
        if (error.response.status === 401) {
          this.$store.dispatch('logout');
        }

        return Promise.reject(error);
      },
    );
  },
  vuetify,
  render: h => h(App),
}).$mount('#app');
